import React from 'react'
import styled from 'styled-components'
import { withNamespaces } from 'react-i18next'
import { useNavigation } from './context'

const Button = styled.button`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #ffffff;
  font-size: 17px;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.16);
  }

  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 1px;
  }
`

/** Ícone de painel lateral (abre/recolhe a barra lateral no computador). */
const PanelIcon = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="4" width="18" height="16" rx="3" stroke="currentColor" strokeWidth="1.8" />
    <path d="M9.5 4v16" stroke="currentColor" strokeWidth="1.8" />
  </svg>
)

/** Botão da barra colorida: recolhe/expande a barra lateral ou abre a gaveta. */
const NavToggle = ({ t }) => {
  const { mode, collapsed, drawerOpen, toggle } = useNavigation()
  const label =
    mode === 'sidebar'
      ? collapsed
        ? t('nav.expand', 'Expandir menu')
        : t('nav.collapse', 'Recolher menu')
      : drawerOpen
      ? t('nav.close', 'Fechar menu')
      : t('nav.open', 'Abrir menu')
  return (
    <Button type="button" onClick={toggle} title={label} aria-label={label}>
      {mode === 'sidebar' ? <PanelIcon /> : <i className="fas fa-bars" aria-hidden="true" />}
    </Button>
  )
}

export default withNamespaces()(NavToggle)
